const countries = [
    {
        "country_name": "Afghanistan",
        "currency_name": "Afghan Afghani",
        "currency": "AFN",
        "currency_with_symbol": "AFN",
        "flag_img": "https://flagpedia.net/data/flags/h80/af.png",
        "country_code": "AF",
        "locale": "fa-AF"
    },
    {
        "country_name": "Albania",
        "currency_name": "Albanian lek",
        "currency": "ALL",
        "currency_with_symbol": "ALL",
        "flag_img": "https://flagpedia.net/data/flags/h80/al.png",
        "country_code": "AL",
        "locale": "sq-AL"
    },
    {
        "country_name": "Algeria",
        "currency_name": "Algerian dinar",
        "currency": "DZD",
        "currency_with_symbol": "DZD",
        "flag_img": "https://flagpedia.net/data/flags/h80/dz.png",
        "country_code": "DZ",
        "locale": "ar-DZ"
    },
    {
        "country_name": "American Samoa",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/as.png",
        "country_code": "AS",
        "locale": "en-US"
    },
    {
        "country_name": "Andorra",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/ad.png",
        "country_code": "AD",
        "locale": "de-DE"
    },
    {
        "country_name": "Angola",
        "currency_name": "Angolan kwanza",
        "currency": "AOA",
        "currency_with_symbol": "AOA",
        "flag_img": "https://flagpedia.net/data/flags/h80/ao.png",
        "country_code": "AO",
        "locale": "pt-AO"
    },
    {
        "country_name": "Anguilla",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ai.png",
        "country_code": "AI",
        "locale": "en-KN"
    },
    {
        "country_name": "Antigua and Barbuda",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ag.png",
        "country_code": "AG",
        "locale": "en-KN"
    },
    {
        "country_name": "Argentina",
        "currency_name": "Argentine peso",
        "currency": "ARS",
        "currency_with_symbol": "ARS",
        "flag_img": "https://flagpedia.net/data/flags/h80/ar.png",
        "country_code": "AR",
        "locale": "es-AR"
    },
    {
        "country_name": "Armenia",
        "currency_name": "Armenian dram",
        "currency": "AMD",
        "currency_with_symbol": "AMD",
        "flag_img": "https://flagpedia.net/data/flags/h80/am.png",
        "country_code": "AM",
        "locale": "hy-AM"
    },
    {
        "country_name": "Aruba",
        "currency_name": "Aruban guilder",
        "currency": "AWG",
        "currency_with_symbol": "AWG",
        "flag_img": "https://flagpedia.net/data/flags/h80/aw.png",
        "country_code": "AW",
        "locale": "nl-AW"
    },
    {
        "country_name": "Australia",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/au.png",
        "country_code": "AU",
        "locale": "en-AU"
    },
    {
        "country_name": "Austria",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/at.png",
        "country_code": "AT",
        "locale": "de-DE"
    },
    {
        "country_name": "Azerbaijan",
        "currency_name": "New azerbaijani Manat",
        "currency": "AZN",
        "currency_with_symbol": "AZN",
        "flag_img": "https://flagpedia.net/data/flags/h80/az.png",
        "country_code": "AZ",
        "locale": "az-AZ"
    },
    {
        "country_name": "Bahamas",
        "currency_name": "Bahamian dollar",
        "currency": "BSD",
        "currency_with_symbol": "BS $",
        "flag_img": "https://flagpedia.net/data/flags/h80/bs.png",
        "country_code": "BS",
        "locale": "en-BS"
    },
    {
        "country_name": "Bahrain",
        "currency_name": "Bahraini dinar",
        "currency": "BHD",
        "currency_with_symbol": "BHD",
        "flag_img": "https://flagpedia.net/data/flags/h80/bh.png",
        "country_code": "BH",
        "locale": "ar-BH"
    },
    {
        "country_name": "Bangladesh",
        "currency_name": "Bangladeshi taka",
        "currency": "BDT",
        "currency_with_symbol": "BDT",
        "flag_img": "https://flagpedia.net/data/flags/h80/bd.png",
        "country_code": "BD",
        "locale": "bn-BD"
    },
    {
        "country_name": "Barbados",
        "currency_name": "Barbados dollar",
        "currency": "BBD",
        "currency_with_symbol": "BB $",
        "flag_img": "https://flagpedia.net/data/flags/h80/bb.png",
        "country_code": "BB",
        "locale": "en-BB"
    },
    {
        "country_name": "Belarus",
        "currency_name": "Belarusian ruble",
        "currency": "BYN",
        "currency_with_symbol": "BYN",
        "flag_img": "https://flagpedia.net/data/flags/h80/by.png",
        "country_code": "BY",
        "locale": "be-BY"
    },
    {
        "country_name": "Belgium",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/be.png",
        "country_code": "BE",
        "locale": "de-DE"
    },
    {
        "country_name": "Belize",
        "currency_name": "Belize dollar",
        "currency": "BZD",
        "currency_with_symbol": "BZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/bz.png",
        "country_code": "BZ",
        "locale": "en-BZ"
    },
    {
        "country_name": "Benin",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/bj.png",
        "country_code": "BJ"
    },
    {
        "country_name": "Bermuda",
        "currency_name": "Bermudian dollar",
        "currency": "BMD",
        "currency_with_symbol": "BM $",
        "flag_img": "https://flagpedia.net/data/flags/h80/bm.png",
        "country_code": "BM",
        "locale": "en-BM"
    },
    {
        "country_name": "Bhutan",
        "currency_name": "Bhutanese ngultrum",
        "currency": "BTN",
        "currency_with_symbol": "BTN",
        "flag_img": "https://flagpedia.net/data/flags/h80/bt.png",
        "country_code": "BT",
        "locale": "dz-BT"
    },
    {
        "country_name": "Bolivia",
        "currency_name": "Boliviano",
        "currency": "BOB",
        "currency_with_symbol": "BOB",
        "flag_img": "https://flagpedia.net/data/flags/h80/bo.png",
        "country_code": "BO",
        "locale": "es-BO"
    },
    {
        "country_name": "Bosnia-Herzegovina",
        "currency_name": "Convertible mark",
        "currency": "BAM",
        "currency_with_symbol": "BAM",
        "flag_img": "https://flagpedia.net/data/flags/h80/ba.png",
        "country_code": "BA",
        "locale": "bs-BA"
    },
    {
        "country_name": "Botswana",
        "currency_name": "Botswana pula",
        "currency": "BWP",
        "currency_with_symbol": "BWP",
        "flag_img": "https://flagpedia.net/data/flags/h80/bw.png",
        "country_code": "BW",
        "locale": "en-BW"
    },
    {
        "country_name": "Bouvet Island",
        "currency_name": "Norwegian krone",
        "currency": "NOK",
        "currency_with_symbol": "NOK",
        "flag_img": "https://flagpedia.net/data/flags/h80/bv.png",
        "country_code": "BV",
        "locale": "nb-NO"
    },
    {
        "country_name": "Brazil",
        "currency_name": "Brazilian real",
        "currency": "BRL",
        "currency_with_symbol": "BRL",
        "flag_img": "https://flagpedia.net/data/flags/h80/br.png",
        "country_code": "BR",
        "locale": "pt-BR"
    },
    {
        "country_name": "British Indian O. Terr.",
        "currency_name": "Pound sterling",
        "currency": "GBP",
        "currency_with_symbol": "GBP",
        "flag_img": "https://flagpedia.net/data/flags/h80/io.png",
        "country_code": "IO",
        "locale": "en-GB"
    },
    {
        "country_name": "British Virgin Islands",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/vg.png",
        "country_code": "VG",
        "locale": "en-US"
    },
    {
        "country_name": "Brunei Darussalam",
        "currency_name": "Brunei dollar",
        "currency": "BND",
        "currency_with_symbol": "BN $",
        "flag_img": "https://flagpedia.net/data/flags/h80/bn.png",
        "country_code": "BN",
        "locale": "ms-BN"
    },
    {
        "country_name": "Bulgaria",
        "currency_name": "Bulgarian lev",
        "currency": "BGN",
        "currency_with_symbol": "BGN",
        "flag_img": "https://flagpedia.net/data/flags/h80/bg.png",
        "country_code": "BG",
        "locale": "bg-BG"
    },
    {
        "country_name": "Burkina Faso",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/bf.png",
        "country_code": "BF"
    },
    {
        "country_name": "Burundi",
        "currency_name": "Burundian franc",
        "currency": "BIF",
        "currency_with_symbol": "BIF",
        "flag_img": "https://flagpedia.net/data/flags/h80/bi.png",
        "country_code": "BI"
    },
    {
        "country_name": "Cambodia",
        "currency_name": "Cambodian riel",
        "currency": "KHR",
        "currency_with_symbol": "KHR",
        "flag_img": "https://flagpedia.net/data/flags/h80/kh.png",
        "country_code": "KH",
        "locale": "km-KH"
    },
    {
        "country_name": "Cameroon",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/cm.png",
        "country_code": "CM",
        "locale": "fr-CM"
    },
    {
        "country_name": "Canada",
        "currency_name": "Canadian dollar",
        "currency": "CAD",
        "currency_with_symbol": "CA $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ca.png",
        "country_code": "CA",
        "locale": "en-CA"
    },
    {
        "country_name": "Cape Verde",
        "currency_name": "Cape Verde escudo",
        "currency": "CVE",
        "currency_with_symbol": "CVE",
        "flag_img": "https://flagpedia.net/data/flags/h80/cv.png",
        "country_code": "CV"
    },
    {
        "country_name": "Cayman Islands",
        "currency_name": "Cayman Islands dollar",
        "currency": "KYD",
        "currency_with_symbol": "KY $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ky.png",
        "country_code": "KY"
    },
    {
        "country_name": "Central African Rep.",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/cf.png",
        "country_code": "CF",
        "locale": "fr-CM"
    },
    {
        "country_name": "Chad",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/td.png",
        "country_code": "TD",
        "locale": "fr-CM"
    },
    {
        "country_name": "Chile",
        "currency_name": "Chilean peso",
        "currency": "CLP",
        "currency_with_symbol": "CLP",
        "flag_img": "https://flagpedia.net/data/flags/h80/cl.png",
        "country_code": "CL"
    },
    {
        "country_name": "China",
        "currency_name": "Chinese yuan renminbi (RMB)",
        "currency": "CNY",
        "currency_with_symbol": "CNY",
        "flag_img": "https://flagpedia.net/data/flags/h80/cn.png",
        "country_code": "CN",
        "locale": "zh-CN"
    },
    {
        "country_name": "Christmas Island",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/cx.png",
        "country_code": "CX",
        "locale": "en-AU"
    },
    {
        "country_name": "Cocos (Keeling) Islands",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/cc.png",
        "country_code": "CC",
        "locale": "en-AU"
    },
    {
        "country_name": "Colombia",
        "currency_name": "Colombian peso",
        "currency": "COP",
        "currency_with_symbol": "COP",
        "flag_img": "https://flagpedia.net/data/flags/h80/co.png",
        "country_code": "CO",
        "locale": "es-CO"
    },
    {
        "country_name": "Comoros",
        "currency_name": "Comoro franc",
        "currency": "KMF",
        "currency_with_symbol": "KMF",
        "flag_img": "https://flagpedia.net/data/flags/h80/km.png",
        "country_code": "KM"
    },
    {
        "country_name": "Congo (Brazzaville)",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/cg.png",
        "country_code": "CG",
        "locale": "fr-CM"
    },
    {
        "country_name": "Cook Islands",
        "currency_name": "New Zealand dollar",
        "currency": "NZD",
        "currency_with_symbol": "NZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ck.png",
        "country_code": "CK",
        "locale": "en-NZ"
    },
    {
        "country_name": "Costa Rica",
        "currency_name": "Costa Rican colon",
        "currency": "CRC",
        "currency_with_symbol": "CRC",
        "flag_img": "https://flagpedia.net/data/flags/h80/cr.png",
        "country_code": "CR",
        "locale": "es-CR"
    },
    {
        "country_name": "Croatia",
        "currency_name": "Croatian kuna",
        "currency": "HRK",
        "currency_with_symbol": "HRK",
        "flag_img": "https://flagpedia.net/data/flags/h80/hr.png",
        "country_code": "HR"
    },
    {
        "country_name": "Cuba",
        "currency_name": "Cuban convertible Peso",
        "currency": "CUC",
        "currency_with_symbol": "CUC",
        "flag_img": "https://flagpedia.net/data/flags/h80/cu.png",
        "country_code": "CU"
    },
    {
        "country_name": "Cyprus",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/cy.png",
        "country_code": "CY",
        "locale": "de-DE"
    },
    {
        "country_name": "Czech Republic",
        "currency_name": "Czech koruna",
        "currency": "CZK",
        "currency_with_symbol": "CZK",
        "flag_img": "https://flagpedia.net/data/flags/h80/cz.png",
        "country_code": "CZ",
        "locale": "cs-CZ"
    },
    {
        "country_name": "Democratic Republic of Congo (Kinshasa-Zaire)",
        "currency_name": "Congolese franc",
        "currency": "CDF",
        "currency_with_symbol": "CDF",
        "flag_img": "https://flagpedia.net/data/flags/h80/cd.png",
        "country_code": "CD"
    },
    {
        "country_name": "Denmark",
        "currency_name": "Danish krone",
        "currency": "DKK",
        "currency_with_symbol": "DKK",
        "flag_img": "https://flagpedia.net/data/flags/h80/dk.png",
        "country_code": "DK",
        "locale": "da-DK"
    },
    {
        "country_name": "Djibouti",
        "currency_name": "Djiboutian franc",
        "currency": "DJF",
        "currency_with_symbol": "DJF",
        "flag_img": "https://flagpedia.net/data/flags/h80/dj.png",
        "country_code": "DJ",
        "locale": "fr-DJ"
    },
    {
        "country_name": "Dominica",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/dm.png",
        "country_code": "DM",
        "locale": "en-KN"
    },
    {
        "country_name": "Dominican Republic",
        "currency_name": "Dominican peso",
        "currency": "DOP",
        "currency_with_symbol": "DOP",
        "flag_img": "https://flagpedia.net/data/flags/h80/do.png",
        "country_code": "DO",
        "locale": "es-DO"
    },
    {
        "country_name": "Ecuador",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/ec.png",
        "country_code": "EC",
        "locale": "en-US"
    },
    {
        "country_name": "Egypt",
        "currency_name": "Egyptian pound",
        "currency": "EGP",
        "currency_with_symbol": "EGP",
        "flag_img": "https://flagpedia.net/data/flags/h80/eg.png",
        "country_code": "EG",
        "locale": "ar-EG"
    },
    {
        "country_name": "El Salvador",
        "currency_name": "Salvadoran colon",
        "currency": "SVC",
        "currency_with_symbol": "SVC",
        "flag_img": "https://flagpedia.net/data/flags/h80/sv.png",
        "country_code": "SV"
    },
    {
        "country_name": "Eritrea",
        "currency_name": "Eritrean nakfa",
        "currency": "ERN",
        "currency_with_symbol": "ERN",
        "flag_img": "https://flagpedia.net/data/flags/h80/er.png",
        "country_code": "ER"
    },
    {
        "country_name": "Estonia",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/ee.png",
        "country_code": "EE",
        "locale": "de-DE"
    },
    {
        "country_name": "Ethiopia",
        "currency_name": "Ethipian birr",
        "currency": "ETB",
        "currency_with_symbol": "ETB",
        "flag_img": "https://flagpedia.net/data/flags/h80/et.png",
        "country_code": "ET",
        "locale": "am-ET"
    },
    {
        "country_name": "European Union",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/eu.png",
        "country_code": "EU",
        "locale": "de-DE"
    },
    {
        "country_name": "Falkland Isl., Malvinas",
        "currency_name": "Falkland Islands pound",
        "currency": "FKP",
        "currency_with_symbol": "FKP",
        "flag_img": "https://flagpedia.net/data/flags/h80/fk.png",
        "country_code": "FK"
    },
    {
        "country_name": "Faroe Islands",
        "currency_name": "Danish krone",
        "currency": "DKK",
        "currency_with_symbol": "DKK",
        "flag_img": "https://flagpedia.net/data/flags/h80/fo.png",
        "country_code": "FO",
        "locale": "da-DK"
    },
    {
        "country_name": "Fiji",
        "currency_name": "Fiji dollar",
        "currency": "FJD",
        "currency_with_symbol": "FJ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/fj.png",
        "country_code": "FJ",
        "locale": "en-FJ"
    },
    {
        "country_name": "Finland",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/fi.png",
        "country_code": "FI",
        "locale": "de-DE"
    },
    {
        "country_name": "France",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/fr.png",
        "country_code": "FR",
        "locale": "de-DE"
    },
    {
        "country_name": "French Guiana",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/gf.png",
        "country_code": "GF",
        "locale": "de-DE"
    },
    {
        "country_name": "French Polynesia",
        "currency_name": "French pacific franc",
        "currency": "XPF",
        "currency_with_symbol": "XPF",
        "flag_img": "https://flagpedia.net/data/flags/h80/pf.png",
        "country_code": "PF"
    },
    {
        "country_name": "French Southern Terr.",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/tf.png",
        "country_code": "TF",
        "locale": "de-DE"
    },
    {
        "country_name": "Gabon",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ga.png",
        "country_code": "GA",
        "locale": "fr-CM"
    },
    {
        "country_name": "Gambia",
        "currency_name": "Gambian dalasi",
        "currency": "GMD",
        "currency_with_symbol": "GMD",
        "flag_img": "https://flagpedia.net/data/flags/h80/gm.png",
        "country_code": "GM"
    },
    {
        "country_name": "Georgia",
        "currency_name": "Georgian lari",
        "currency": "GEL",
        "currency_with_symbol": "GEL",
        "flag_img": "https://flagpedia.net/data/flags/h80/ge.png",
        "country_code": "GE"
    },
    {
        "country_name": "Germany",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/de.png",
        "country_code": "DE",
        "locale": "de-DE"
    },
    {
        "country_name": "Ghana",
        "currency_name": "Ghanaian Cedi",
        "currency": "GHS",
        "currency_with_symbol": "GHS",
        "flag_img": "https://flagpedia.net/data/flags/h80/gh.png",
        "country_code": "GH",
        "locale": "en-GH"
    },
    {
        "country_name": "Gibraltar",
        "currency_name": "Gibraltar pound",
        "currency": "GIP",
        "currency_with_symbol": "GIP",
        "flag_img": "https://flagpedia.net/data/flags/h80/gi.png",
        "country_code": "GI"
    },
    {
        "country_name": "Greece",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/gr.png",
        "country_code": "GR",
        "locale": "de-DE"
    },
    {
        "country_name": "Greenland (Denmark)",
        "currency_name": "Danish krone",
        "currency": "DKK",
        "currency_with_symbol": "DKK",
        "flag_img": "https://flagpedia.net/data/flags/h80/gl.png",
        "country_code": "GL",
        "locale": "da-DK"
    },
    {
        "country_name": "Grenada",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/gd.png",
        "country_code": "GD",
        "locale": "en-KN"
    },
    {
        "country_name": "Guadaloupe",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/gp.png",
        "country_code": "GP",
        "locale": "de-DE"
    },
    {
        "country_name": "Guam (US)",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/gu.png",
        "country_code": "GU",
        "locale": "en-US"
    },
    {
        "country_name": "Guatemala",
        "currency_name": "Guatemalan quetzal",
        "currency": "GTQ",
        "currency_with_symbol": "GTQ",
        "flag_img": "https://flagpedia.net/data/flags/h80/gt.png",
        "country_code": "GT"
    },
    {
        "country_name": "Guernsey",
        "currency_name": "Guernsey Pound",
        "currency": "GGP",
        "currency_with_symbol": "GGP",
        "flag_img": "https://flagpedia.net/data/flags/h80/gg.png",
        "country_code": "GG"
    },
    {
        "country_name": "Guinea (Conakry)",
        "currency_name": "Guinean franc",
        "currency": "GNF",
        "currency_with_symbol": "GNF",
        "flag_img": "https://flagpedia.net/data/flags/h80/gn.png",
        "country_code": "GN"
    },
    {
        "country_name": "Guinea Bissau",
        "currency_name": "CFA Franc BEAC",
        "currency": "XAF",
        "currency_with_symbol": "XAF",
        "flag_img": "https://flagpedia.net/data/flags/h80/gw.png",
        "country_code": "GW",
        "locale": "fr-CM"
    },
    {
        "country_name": "Guyana",
        "currency_name": "Guyanese dollar",
        "currency": "GYD",
        "currency_with_symbol": "GY $",
        "flag_img": "https://flagpedia.net/data/flags/h80/gy.png",
        "country_code": "GY"
    },
    {
        "country_name": "Haiti",
        "currency_name": "Haitian gourde",
        "currency": "HTG",
        "currency_with_symbol": "HTG",
        "flag_img": "https://flagpedia.net/data/flags/h80/ht.png",
        "country_code": "HT"
    },
    {
        "country_name": "Heard and McDonald Isl.",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/hm.png",
        "country_code": "HM",
        "locale": "en-AU"
    },
    {
        "country_name": "Honduras",
        "currency_name": "Honduran lempira",
        "currency": "HNL",
        "currency_with_symbol": "HNL",
        "flag_img": "https://flagpedia.net/data/flags/h80/hn.png",
        "country_code": "HN"
    },
    {
        "country_name": "Hong Kong",
        "currency_name": "Hong Kong dollar",
        "currency": "HKD",
        "currency_with_symbol": "HK $",
        "flag_img": "https://flagpedia.net/data/flags/h80/hk.png",
        "country_code": "HK",
        "locale": "zh-HK"
    },
    {
        "country_name": "Hungary",
        "currency_name": "Hungarian forint",
        "currency": "HUF",
        "currency_with_symbol": "HUF",
        "flag_img": "https://flagpedia.net/data/flags/h80/hu.png",
        "country_code": "HU",
        "locale": "hu-HU"
    },
    {
        "country_name": "Iceland",
        "currency_name": "Icelandic króna",
        "currency": "ISK",
        "currency_with_symbol": "ISK",
        "flag_img": "https://flagpedia.net/data/flags/h80/is.png",
        "country_code": "IS"
    },
    {
        "country_name": "India",
        "currency_name": "Indian rupee",
        "currency": "INR",
        "currency_with_symbol": "₹",
        "flag_img": "https://flagpedia.net/data/flags/h80/in.png",
        "country_code": "IN",
        "locale": "en-IN"
    },
    {
        "country_name": "Indonesia",
        "currency_name": "Indonesian rupiah",
        "currency": "IDR",
        "currency_with_symbol": "Rp ",
        "flag_img": "https://flagpedia.net/data/flags/h80/id.png",
        "country_code": "ID",
        "locale": "id-ID"
    },
    {
        "country_name": "Iran",
        "currency_name": "Iranian rial",
        "currency": "IRR",
        "currency_with_symbol": "IRR",
        "flag_img": "https://flagpedia.net/data/flags/h80/ir.png",
        "country_code": "IR"
    },
    {
        "country_name": "Iraq",
        "currency_name": "Iraqi dinar",
        "currency": "IQD",
        "currency_with_symbol": "IQD",
        "flag_img": "https://flagpedia.net/data/flags/h80/iq.png",
        "country_code": "IQ"
    },
    {
        "country_name": "Ireland",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/ie.png",
        "country_code": "IE",
        "locale": "de-DE"
    },
    {
        "country_name": "Isle of Man",
        "currency_name": "Manx pound",
        "currency": "IMP",
        "currency_with_symbol": "IMP",
        "flag_img": "https://flagpedia.net/data/flags/h80/im.png",
        "country_code": "IM"
    },
    {
        "country_name": "Israel",
        "currency_name": "Israeli new shekel",
        "currency": "ILS",
        "currency_with_symbol": "ILS",
        "flag_img": "https://flagpedia.net/data/flags/h80/il.png",
        "country_code": "IL",
        "locale": "he-IL"
    },
    {
        "country_name": "Italy",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/it.png",
        "country_code": "IT",
        "locale": "de-DE"
    },
    {
        "country_name": "Ivory Coast",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ci.png",
        "country_code": "CI"
    },
    {
        "country_name": "Jamaica",
        "currency_name": "Jamaican dollar",
        "currency": "JMD",
        "currency_with_symbol": "JM $",
        "flag_img": "https://flagpedia.net/data/flags/h80/jm.png",
        "country_code": "JM",
        "locale": "en-JM"
    },
    {
        "country_name": "Japan",
        "currency_name": "Japanese yen",
        "currency": "JPY",
        "currency_with_symbol": "JP ¥",
        "flag_img": "https://flagpedia.net/data/flags/h80/jp.png",
        "country_code": "JP",
        "locale": "ja-JP"
    },
    {
        "country_name": "Jersey",
        "currency_name": "Jersey pound",
        "currency": "JEP",
        "currency_with_symbol": "JEP",
        "flag_img": "https://flagpedia.net/data/flags/h80/je.png",
        "country_code": "JE"
    },
    {
        "country_name": "Jordan",
        "currency_name": "Jordanian dinar",
        "currency": "JOD",
        "currency_with_symbol": "JOD",
        "flag_img": "https://flagpedia.net/data/flags/h80/jo.png",
        "country_code": "JO"
    },
    {
        "country_name": "Kazakhstan",
        "currency_name": "Kazakhstani tenge",
        "currency": "KZT",
        "currency_with_symbol": "KZT",
        "flag_img": "https://flagpedia.net/data/flags/h80/kz.png",
        "country_code": "KZ"
    },
    {
        "country_name": "Kenya",
        "currency_name": "Kenyan shilling",
        "currency": "KES",
        "currency_with_symbol": "KES",
        "flag_img": "https://flagpedia.net/data/flags/h80/ke.png",
        "country_code": "KE",
        "locale": "en-KE"
    },
    {
        "country_name": "Kiribati",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ki.png",
        "country_code": "KI",
        "locale": "en-AU"
    },
    {
        "country_name": "Kuwait",
        "currency_name": "Kuwaiti dinar",
        "currency": "KWD",
        "currency_with_symbol": "KWD",
        "flag_img": "https://flagpedia.net/data/flags/h80/kw.png",
        "country_code": "KW",
        "locale": "ar-KW"
    },
    {
        "country_name": "Kyrgyz Republic",
        "currency_name": "Kyrgyzstani som",
        "currency": "KGS",
        "currency_with_symbol": "KGS",
        "flag_img": "https://flagpedia.net/data/flags/h80/kg.png",
        "country_code": "KG"
    },
    {
        "country_name": "Laos",
        "currency_name": "Lao kip",
        "currency": "LAK",
        "currency_with_symbol": "LAK",
        "flag_img": "https://flagpedia.net/data/flags/h80/la.png",
        "country_code": "LA"
    },
    {
        "country_name": "Latvia",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/lv.png",
        "country_code": "LV",
        "locale": "de-DE"
    },
    {
        "country_name": "Lebanon",
        "currency_name": "Lebanese pound",
        "currency": "LBP",
        "currency_with_symbol": "LBP",
        "flag_img": "https://flagpedia.net/data/flags/h80/lb.png",
        "country_code": "LB",
        "locale": "ar-LB"
    },
    {
        "country_name": "Lesotho",
        "currency_name": "Lesotho loti",
        "currency": "LSL",
        "currency_with_symbol": "LSL",
        "flag_img": "https://flagpedia.net/data/flags/h80/ls.png",
        "country_code": "LS"
    },
    {
        "country_name": "Liberia",
        "currency_name": "Liberian dollar",
        "currency": "LRD",
        "currency_with_symbol": "LR $",
        "flag_img": "https://flagpedia.net/data/flags/h80/lr.png",
        "country_code": "LR"
    },
    {
        "country_name": "Libya",
        "currency_name": "Libyan dinar",
        "currency": "LYD",
        "currency_with_symbol": "LYD",
        "flag_img": "https://flagpedia.net/data/flags/h80/ly.png",
        "country_code": "LY"
    },
    {
        "country_name": "Liechtenstein",
        "currency_name": "Swiss franc",
        "currency": "CHF",
        "currency_with_symbol": "CHF",
        "flag_img": "https://flagpedia.net/data/flags/h80/li.png",
        "country_code": "LI",
        "locale": "de-CH"
    },
    {
        "country_name": "Lithuania",
        "currency_name": "Lithuanian litas",
        "currency": "LTL",
        "currency_with_symbol": "LTL",
        "flag_img": "https://flagpedia.net/data/flags/h80/lt.png",
        "country_code": "LT"
    },
    {
        "country_name": "Luxembourg",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/lu.png",
        "country_code": "LU",
        "locale": "de-DE"
    },
    {
        "country_name": "Macau",
        "currency_name": "Macanese pataca",
        "currency": "MOP",
        "currency_with_symbol": "MOP",
        "flag_img": "https://flagpedia.net/data/flags/h80/mo.png",
        "country_code": "MO"
    },
    {
        "country_name": "Macedonia",
        "currency_name": "Macedonian denar",
        "currency": "MKD",
        "currency_with_symbol": "MKD",
        "flag_img": "https://flagpedia.net/data/flags/h80/mk.png",
        "country_code": "MK"
    },
    {
        "country_name": "Madagascar",
        "currency_name": "Malagasy ariayry",
        "currency": "MGA",
        "currency_with_symbol": "MGA",
        "flag_img": "https://flagpedia.net/data/flags/h80/mg.png",
        "country_code": "MG"
    },
    {
        "country_name": "Malawi",
        "currency_name": "Malawian kwacha",
        "currency": "MWK",
        "currency_with_symbol": "MWK",
        "flag_img": "https://flagpedia.net/data/flags/h80/mw.png",
        "country_code": "MW"
    },
    {
        "country_name": "Malaysia",
        "currency_name": "Malaysian ringgit",
        "currency": "MYR",
        "currency_with_symbol": "RM ",
        "flag_img": "https://flagpedia.net/data/flags/h80/my.png",
        "country_code": "MY",
        "locale": "ms-MY"
    },
    {
        "country_name": "Maldives",
        "currency_name": "Maldivian rufiyaa",
        "currency": "MVR",
        "currency_with_symbol": "MVR",
        "flag_img": "https://flagpedia.net/data/flags/h80/mv.png",
        "country_code": "MV"
    },
    {
        "country_name": "Mali",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ml.png",
        "country_code": "ML"
    },
    {
        "country_name": "Malta",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/mt.png",
        "country_code": "MT",
        "locale": "de-DE"
    },
    {
        "country_name": "Marshall Islands",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/mh.png",
        "country_code": "MH",
        "locale": "en-US"
    },
    {
        "country_name": "Martinique",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/mq.png",
        "country_code": "MQ",
        "locale": "de-DE"
    },
    {
        "country_name": "Mauritania",
        "currency_name": "Mauritanian ouguiya",
        "currency": "MRO",
        "currency_with_symbol": "MRO",
        "flag_img": "https://flagpedia.net/data/flags/h80/mr.png",
        "country_code": "MR"
    },
    {
        "country_name": "Mauritius",
        "currency_name": "Mauritian rupee",
        "currency": "MUR",
        "currency_with_symbol": "MUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/mu.png",
        "country_code": "MU"
    },
    {
        "country_name": "Mayotte",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/yt.png",
        "country_code": "YT",
        "locale": "de-DE"
    },
    {
        "country_name": "Mexico",
        "currency_name": "Mexican peso",
        "currency": "MXN",
        "currency_with_symbol": "MXN",
        "flag_img": "https://flagpedia.net/data/flags/h80/mx.png",
        "country_code": "MX",
        "locale": "es-MX"
    },
    {
        "country_name": "Micronesia",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/fm.png",
        "country_code": "FM",
        "locale": "en-US"
    },
    {
        "country_name": "Moldova",
        "currency_name": "Moldovan leu",
        "currency": "MDL",
        "currency_with_symbol": "MDL",
        "flag_img": "https://flagpedia.net/data/flags/h80/md.png",
        "country_code": "MD"
    },
    {
        "country_name": "Monaco",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/mc.png",
        "country_code": "MC",
        "locale": "de-DE"
    },
    {
        "country_name": "Mongolia",
        "currency_name": "Mongolian tugrik",
        "currency": "MNT",
        "currency_with_symbol": "MNT",
        "flag_img": "https://flagpedia.net/data/flags/h80/mn.png",
        "country_code": "MN"
    },
    {
        "country_name": "Montenegro",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/me.png",
        "country_code": "ME",
        "locale": "de-DE"
    },
    {
        "country_name": "Montserrat",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/ms.png",
        "country_code": "MS",
        "locale": "en-KN"
    },
    {
        "country_name": "Morocco",
        "currency_name": "Moroccan dirham",
        "currency": "MAD",
        "currency_with_symbol": "MAD",
        "flag_img": "https://flagpedia.net/data/flags/h80/ma.png",
        "country_code": "MA",
        "locale": "ar-MA"
    },
    {
        "country_name": "Mozambique",
        "currency_name": "Mozambican metical",
        "currency": "MZN",
        "currency_with_symbol": "MZN",
        "flag_img": "https://flagpedia.net/data/flags/h80/mz.png",
        "country_code": "MZ"
    },
    {
        "country_name": "Myanmar",
        "currency_name": "Myanma kyat",
        "currency": "MMK",
        "currency_with_symbol": "MMK",
        "flag_img": "https://flagpedia.net/data/flags/h80/mm.png",
        "country_code": "MM"
    },
    {
        "country_name": "Namibia",
        "currency_name": "Namibian dollar",
        "currency": "NAD",
        "currency_with_symbol": "NA $",
        "flag_img": "https://flagpedia.net/data/flags/h80/na.png",
        "country_code": "NA"
    },
    {
        "country_name": "Nauru",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/nr.png",
        "country_code": "NR",
        "locale": "en-AU"
    },
    {
        "country_name": "Nepal",
        "currency_name": "Nepalese rupee",
        "currency": "NPR",
        "currency_with_symbol": "NPR",
        "flag_img": "https://flagpedia.net/data/flags/h80/np.png",
        "country_code": "NP",
        "locale": "ne-NP"
    },
    {
        "country_name": "Netherland Antilles",
        "currency_name": "Netherlands Antillean guilder",
        "currency": "ANG",
        "currency_with_symbol": "ANG",
        "flag_img": "https://flagpedia.net/data/flags/h80/an.png",
        "country_code": "AN"
    },
    {
        "country_name": "Netherlands",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/nl.png",
        "country_code": "NL",
        "locale": "de-DE"
    },
    {
        "country_name": "New Caledonia",
        "currency_name": "French pacific franc",
        "currency": "XPF",
        "currency_with_symbol": "XPF",
        "flag_img": "https://flagpedia.net/data/flags/h80/nc.png",
        "country_code": "NC"
    },
    {
        "country_name": "New Zealand",
        "currency_name": "New Zealand dollar",
        "currency": "NZD",
        "currency_with_symbol": "NZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/nz.png",
        "country_code": "NZ",
        "locale": "en-NZ"
    },
    {
        "country_name": "Nicaragua",
        "currency_name": "Nicaraguan córdoba",
        "currency": "NIO",
        "currency_with_symbol": "NIO",
        "flag_img": "https://flagpedia.net/data/flags/h80/ni.png",
        "country_code": "NI"
    },
    {
        "country_name": "Niger",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ne.png",
        "country_code": "NE"
    },
    {
        "country_name": "Nigeria",
        "currency_name": "Nigerian naira",
        "currency": "NGN",
        "currency_with_symbol": "NGN",
        "flag_img": "https://flagpedia.net/data/flags/h80/ng.png",
        "country_code": "NG",
        "locale": "en-NG"
    },
    {
        "country_name": "Niue",
        "currency_name": "New Zealand dollar",
        "currency": "NZD",
        "currency_with_symbol": "NZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/nu.png",
        "country_code": "NU",
        "locale": "en-NZ"
    },
    {
        "country_name": "Norfolk Island",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/nf.png",
        "country_code": "NF",
        "locale": "en-AU"
    },
    {
        "country_name": "North Korea",
        "currency_name": "North Korean won",
        "currency": "KPW",
        "currency_with_symbol": "KPW",
        "flag_img": "https://flagpedia.net/data/flags/h80/kp.png",
        "country_code": "KP"
    },
    {
        "country_name": "Northern Mariana Isl.",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/mp.png",
        "country_code": "MP",
        "locale": "en-US"
    },
    {
        "country_name": "Norway",
        "currency_name": "Norwegian krone",
        "currency": "NOK",
        "currency_with_symbol": "kr ",
        "flag_img": "https://flagpedia.net/data/flags/h80/no.png",
        "country_code": "NO",
        "locale": "nb-NO"
    },
    {
        "country_name": "Oman",
        "currency_name": "Omani rial",
        "currency": "OMR",
        "currency_with_symbol": "OMR",
        "flag_img": "https://flagpedia.net/data/flags/h80/om.png",
        "country_code": "OM",
        "locale": "ar-OM"
    },
    {
        "country_name": "Pakistan",
        "currency_name": "Pakistani rupee",
        "currency": "PKR",
        "currency_with_symbol": "PKR",
        "flag_img": "https://flagpedia.net/data/flags/h80/pk.png",
        "country_code": "PK",
        "locale": "ur-PK"
    },
    {
        "country_name": "Palau",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/pw.png",
        "country_code": "PW",
        "locale": "en-US"
    },
    {
        "country_name": "Palestine",
        "currency_name": "Israeli new shekel",
        "currency": "ILS",
        "currency_with_symbol": "ILS",
        "flag_img": "https://flagpedia.net/data/flags/h80/ps.png",
        "country_code": "PS",
        "locale": "he-IL"
    },
    {
        "country_name": "Panama",
        "currency_name": "Panamanian balboa",
        "currency": "PAB",
        "currency_with_symbol": "PAB",
        "flag_img": "https://flagpedia.net/data/flags/h80/pa.png",
        "country_code": "PA"
    },
    {
        "country_name": "Papua New Guinea",
        "currency_name": "Papua New Guinean kina",
        "currency": "PGK",
        "currency_with_symbol": "PGK",
        "flag_img": "https://flagpedia.net/data/flags/h80/pg.png",
        "country_code": "PG"
    },
    {
        "country_name": "Paraguay",
        "currency_name": "Paraguayan guaraní",
        "currency": "PYG",
        "currency_with_symbol": "PYG",
        "flag_img": "https://flagpedia.net/data/flags/h80/py.png",
        "country_code": "PY"
    },
    {
        "country_name": "Peru",
        "currency_name": "Peruvian nuevo sol",
        "currency": "PEN",
        "currency_with_symbol": "PEN",
        "flag_img": "https://flagpedia.net/data/flags/h80/pe.png",
        "country_code": "PE"
    },
    {
        "country_name": "Philippines",
        "currency_name": "Philippine peso",
        "currency": "PHP",
        "currency_with_symbol": "₱",
        "flag_img": "https://flagpedia.net/data/flags/h80/ph.png",
        "country_code": "PH",
        "locale": "fil-PH"
    },
    {
        "country_name": "Pitcairn",
        "currency_name": "New Zealand dollar",
        "currency": "NZD",
        "currency_with_symbol": "NZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/pn.png",
        "country_code": "PN",
        "locale": "en-NZ"
    },
    {
        "country_name": "Poland",
        "currency_name": "Polish zloty",
        "currency": "PLN",
        "currency_with_symbol": "PLN",
        "flag_img": "https://flagpedia.net/data/flags/h80/pl.png",
        "country_code": "PL",
        "locale": "pl-PL"
    },
    {
        "country_name": "Portugal",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/pt.png",
        "country_code": "PT",
        "locale": "de-DE"
    },
    {
        "country_name": "Puerto Rico",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/pr.png",
        "country_code": "PR",
        "locale": "en-US"
    },
    {
        "country_name": "Qatar",
        "currency_name": "Qatari riyal",
        "currency": "QAR",
        "currency_with_symbol": "QAR",
        "flag_img": "https://flagpedia.net/data/flags/h80/qa.png",
        "country_code": "QA",
        "locale": "ar-QA"
    },
    {
        "country_name": "Reunion",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/re.png",
        "country_code": "RE",
        "locale": "de-DE"
    },
    {
        "country_name": "Romania",
        "currency_name": "Romanian new Leu",
        "currency": "RON",
        "currency_with_symbol": "RON",
        "flag_img": "https://flagpedia.net/data/flags/h80/ro.png",
        "country_code": "RO",
        "locale": "ro-RO"
    },
    {
        "country_name": "Russian Federation",
        "currency_name": "Russian ruble",
        "currency": "RUB",
        "currency_with_symbol": "RUB",
        "flag_img": "https://flagpedia.net/data/flags/h80/ru.png",
        "country_code": "RU",
        "locale": "ru-RU"
    },
    {
        "country_name": "Rwanda",
        "currency_name": "Rwandan franc",
        "currency": "RWF",
        "currency_with_symbol": "RWF",
        "flag_img": "https://flagpedia.net/data/flags/h80/rw.png",
        "country_code": "RW"
    },
    {
        "country_name": "Saint Lucia",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/lc.png",
        "country_code": "LC",
        "locale": "en-KN"
    },
    {
        "country_name": "Saint Pierre and Miquelon",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/pm.png",
        "country_code": "PM",
        "locale": "de-DE"
    },
    {
        "country_name": "San Marino",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/sm.png",
        "country_code": "SM",
        "locale": "de-DE"
    },
    {
        "country_name": "Saudi Arabia",
        "currency_name": "Saudi riyal",
        "currency": "SAR",
        "currency_with_symbol": "SAR",
        "flag_img": "https://flagpedia.net/data/flags/h80/sa.png",
        "country_code": "SA",
        "locale": "ar-SA"
    },
    {
        "country_name": "Senegal",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/sn.png",
        "country_code": "SN"
    },
    {
        "country_name": "Serbia",
        "currency_name": "Serbian dinar",
        "currency": "RSD",
        "currency_with_symbol": "RSD",
        "flag_img": "https://flagpedia.net/data/flags/h80/rs.png",
        "country_code": "RS"
    },
    {
        "country_name": "Seychelles",
        "currency_name": "Seychelles rupee",
        "currency": "SCR",
        "currency_with_symbol": "SCR",
        "flag_img": "https://flagpedia.net/data/flags/h80/sc.png",
        "country_code": "SC"
    },
    {
        "country_name": "Sierra Leone",
        "currency_name": "Sierra Leonean leone",
        "currency": "SLL",
        "currency_with_symbol": "SLL",
        "flag_img": "https://flagpedia.net/data/flags/h80/sl.png",
        "country_code": "SL"
    },
    {
        "country_name": "Singapore",
        "currency_name": "Singapore dollar",
        "currency": "SGD",
        "currency_with_symbol": "SG $",
        "flag_img": "https://flagpedia.net/data/flags/h80/sg.png",
        "country_code": "SG",
        "locale": "en-SG"
    },
    {
        "country_name": "Sint Maarten (Dutch part)",
        "currency_name": "Netherlands Antillean guilder",
        "currency": "ANG",
        "currency_with_symbol": "ANG",
        "flag_img": "https://flagpedia.net/data/flags/h80/sx.png",
        "country_code": "SX"
    },
    {
        "country_name": "Slovakia",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/sk.png",
        "country_code": "SK",
        "locale": "de-DE"
    },
    {
        "country_name": "Slovenia",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/si.png",
        "country_code": "SI",
        "locale": "de-DE"
    },
    {
        "country_name": "Solomon Islands",
        "currency_name": "Solomon Islands dollar",
        "currency": "SBD",
        "currency_with_symbol": "SB $",
        "flag_img": "https://flagpedia.net/data/flags/h80/sb.png",
        "country_code": "SB"
    },
    {
        "country_name": "Somalia",
        "currency_name": "Somali shilling",
        "currency": "SOS",
        "currency_with_symbol": "SOS",
        "flag_img": "https://flagpedia.net/data/flags/h80/so.png",
        "country_code": "SO"
    },
    {
        "country_name": "South Africa",
        "currency_name": "South African rand",
        "currency": "ZAR",
        "currency_with_symbol": "ZAR",
        "flag_img": "https://flagpedia.net/data/flags/h80/za.png",
        "country_code": "ZA",
        "locale": "en-ZA"
    },
    {
        "country_name": "South Georgia and South Sandwich Islands",
        "currency_name": "Pound sterling",
        "currency": "GBP",
        "currency_with_symbol": "GBP",
        "flag_img": "https://flagpedia.net/data/flags/h80/gs.png",
        "country_code": "GS",
        "locale": "en-GB"
    },
    {
        "country_name": "South Korea",
        "currency_name": "South Korean won",
        "currency": "KRW",
        "currency_with_symbol": "KRW",
        "flag_img": "https://flagpedia.net/data/flags/h80/kr.png",
        "country_code": "KR",
        "locale": "ko-KR"
    },
    {
        "country_name": "South Sudan",
        "currency_name": "South Sudanese Pound",
        "currency": "SSP",
        "currency_with_symbol": "SSP",
        "flag_img": "https://flagpedia.net/data/flags/h80/ss.png",
        "country_code": "SS"
    },
    {
        "country_name": "Spain",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/es.png",
        "country_code": "ES",
        "locale": "de-DE"
    },
    {
        "country_name": "Sri Lanka",
        "currency_name": "Sri Lankan rupee",
        "currency": "LKR",
        "currency_with_symbol": "LKR",
        "flag_img": "https://flagpedia.net/data/flags/h80/lk.png",
        "country_code": "LK"
    },
    {
        "country_name": "St. Helena",
        "currency_name": "Saint Helena pound",
        "currency": "SHP",
        "currency_with_symbol": "SHP",
        "flag_img": "https://flagpedia.net/data/flags/h80/sh.png",
        "country_code": "SH"
    },
    {
        "country_name": "St. Tome and Principe",
        "currency_name": "São Tomé dobra",
        "currency": "STD",
        "currency_with_symbol": "STD",
        "flag_img": "https://flagpedia.net/data/flags/h80/st.png",
        "country_code": "ST"
    },
    {
        "country_name": "St.Kitts Nevis Anguilla",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/kn.png",
        "country_code": "KN",
        "locale": "en-KN"
    },
    {
        "country_name": "St.Vincent and Grenadines",
        "currency_name": "East Caribbean dollar",
        "currency": "XCD",
        "currency_with_symbol": "XC $",
        "flag_img": "https://flagpedia.net/data/flags/h80/vc.png",
        "country_code": "VC",
        "locale": "en-KN"
    },
    {
        "country_name": "Sudan",
        "currency_name": "Sudanese pound",
        "currency": "SDG",
        "currency_with_symbol": "SDG",
        "flag_img": "https://flagpedia.net/data/flags/h80/sd.png",
        "country_code": "SD"
    },
    {
        "country_name": "Suriname",
        "currency_name": "Surinamese dollar",
        "currency": "SRD",
        "currency_with_symbol": "SR $",
        "flag_img": "https://flagpedia.net/data/flags/h80/sr.png",
        "country_code": "SR"
    },
    {
        "country_name": "Svalbard and Jan Mayen Is",
        "currency_name": "Norwegian krone",
        "currency": "NOK",
        "currency_with_symbol": "NOK",
        "flag_img": "https://flagpedia.net/data/flags/h80/sj.png",
        "country_code": "SJ",
        "locale": "nb-NO"
    },
    {
        "country_name": "Swaziland",
        "currency_name": "Swazi lilangeni",
        "currency": "SZL",
        "currency_with_symbol": "SZL",
        "flag_img": "https://flagpedia.net/data/flags/h80/sz.png",
        "country_code": "SZ"
    },
    {
        "country_name": "Sweden",
        "currency_name": "Swedish krona",
        "currency": "SEK",
        "currency_with_symbol": "SEK",
        "flag_img": "https://flagpedia.net/data/flags/h80/se.png",
        "country_code": "SE",
        "locale": "sv-SE"
    },
    {
        "country_name": "Switzerland",
        "currency_name": "Swiss franc",
        "currency": "CHF",
        "currency_with_symbol": "CHF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ch.png",
        "country_code": "CH",
        "locale": "de-CH"
    },
    {
        "country_name": "Syria",
        "currency_name": "Syrian pound",
        "currency": "SYP",
        "currency_with_symbol": "SYP",
        "flag_img": "https://flagpedia.net/data/flags/h80/sy.png",
        "country_code": "SY"
    },
    {
        "country_name": "Taiwan",
        "currency_name": "New Taiwan dollar",
        "currency": "TWD",
        "currency_with_symbol": "TW $",
        "flag_img": "https://flagpedia.net/data/flags/h80/tw.png",
        "country_code": "TW"
    },
    {
        "country_name": "Tajikistan",
        "currency_name": "Tajikistani somoni",
        "currency": "TJS",
        "currency_with_symbol": "TJS",
        "flag_img": "https://flagpedia.net/data/flags/h80/tj.png",
        "country_code": "TJ"
    },
    {
        "country_name": "Tanzania",
        "currency_name": "Tanzanian shilling",
        "currency": "TZS",
        "currency_with_symbol": "TZS",
        "flag_img": "https://flagpedia.net/data/flags/h80/tz.png",
        "country_code": "TZ"
    },
    {
        "country_name": "Thailand",
        "currency_name": "Thai baht",
        "currency": "THB",
        "currency_with_symbol": "฿",
        "flag_img": "https://flagpedia.net/data/flags/h80/th.png",
        "country_code": "TH",
        "locale": "th-TH"
    },
    {
        "country_name": "Timor-Leste",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/tl.png",
        "country_code": "TL",
        "locale": "en-US"
    },
    {
        "country_name": "Togo",
        "currency_name": "CFA Franc BCEAO",
        "currency": "XOF",
        "currency_with_symbol": "XOF",
        "flag_img": "https://flagpedia.net/data/flags/h80/tg.png",
        "country_code": "TG"
    },
    {
        "country_name": "Tokelau",
        "currency_name": "New Zealand dollar",
        "currency": "NZD",
        "currency_with_symbol": "NZ $",
        "flag_img": "https://flagpedia.net/data/flags/h80/tk.png",
        "country_code": "TK",
        "locale": "en-NZ"
    },
    {
        "country_name": "Tonga",
        "currency_name": "Tongan pa'anga",
        "currency": "TOP",
        "currency_with_symbol": "TOP",
        "flag_img": "https://flagpedia.net/data/flags/h80/to.png",
        "country_code": "TO"
    },
    {
        "country_name": "Trinidad and Tobago",
        "currency_name": "Trinidad dollar",
        "currency": "TTD",
        "currency_with_symbol": "TT $",
        "flag_img": "https://flagpedia.net/data/flags/h80/tt.png",
        "country_code": "TT"
    },
    {
        "country_name": "Tunisia",
        "currency_name": "Tunisian dinar",
        "currency": "TND",
        "currency_with_symbol": "TND",
        "flag_img": "https://flagpedia.net/data/flags/h80/tn.png",
        "country_code": "TN"
    },
    {
        "country_name": "Turkey",
        "currency_name": "Turkish lira",
        "currency": "TRY",
        "currency_with_symbol": "TRY",
        "flag_img": "https://flagpedia.net/data/flags/h80/tr.png",
        "country_code": "TR",
        "locale": "tr-TR"
    },
    {
        "country_name": "Turkmenistan",
        "currency_name": "Turkmenistani new manat",
        "currency": "TMT",
        "currency_with_symbol": "TMT",
        "flag_img": "https://flagpedia.net/data/flags/h80/tm.png",
        "country_code": "TM"
    },
    {
        "country_name": "Turks and Caicos Islands",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/tc.png",
        "country_code": "TC",
        "locale": "en-US"
    },
    {
        "country_name": "Tuvalu",
        "currency_name": "Australian dollar",
        "currency": "AUD",
        "currency_with_symbol": "AU $",
        "flag_img": "https://flagpedia.net/data/flags/h80/tv.png",
        "country_code": "TV",
        "locale": "en-AU"
    },
    {
        "country_name": "Uganda",
        "currency_name": "Ugandan shilling",
        "currency": "UGX",
        "currency_with_symbol": "UGX",
        "flag_img": "https://flagpedia.net/data/flags/h80/ug.png",
        "country_code": "UG"
    },
    {
        "country_name": "Ukraine",
        "currency_name": "Ukrainian hryvnia",
        "currency": "UAH",
        "currency_with_symbol": "UAH",
        "flag_img": "https://flagpedia.net/data/flags/h80/ua.png",
        "country_code": "UA",
        "locale": "uk-UA"
    },
    {
        "country_name": "United Arab Emirates",
        "currency_name": "UAE dirham",
        "currency": "AED",
        "currency_with_symbol": "AED",
        "flag_img": "https://flagpedia.net/data/flags/h80/ae.png",
        "country_code": "AE",
        "locale": "ar-AE"
    },
    {
        "country_name": "United Kingdom",
        "currency_name": "Pound sterling",
        "currency": "GBP",
        "currency_with_symbol": "GBP",
        "flag_img": "https://flagpedia.net/data/flags/h80/gb.png",
        "country_code": "GB",
        "locale": "en-GB"
    },
    {
        "country_name": "United States",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/us.png",
        "country_code": "US",
        "locale": "en-US"
    },
    {
        "country_name": "Uruguay",
        "currency_name": "Urugayan peso",
        "currency": "UYU",
        "currency_with_symbol": "UYU",
        "flag_img": "https://flagpedia.net/data/flags/h80/uy.png",
        "country_code": "UY",
        "locale": "es-UY"
    },
    {
        "country_name": "US Minor outlying Isl.",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/um.png",
        "country_code": "UM",
        "locale": "en-US"
    },
    {
        "country_name": "US Virgin Islands",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/vi.png",
        "country_code": "VI",
        "locale": "en-US"
    },
    {
        "country_name": "Uzbekistan",
        "currency_name": "Uzbekitan som",
        "currency": "UZS",
        "currency_with_symbol": "so'm ",
        "flag_img": "https://flagpedia.net/data/flags/h80/uz.png",
        "country_code": "UZ"
    },
    {
        "country_name": "Vanuatu",
        "currency_name": "Vanuatu vatu",
        "currency": "VUV",
        "currency_with_symbol": "VUV",
        "flag_img": "https://flagpedia.net/data/flags/h80/vu.png",
        "country_code": "VU"
    },
    {
        "country_name": "Vatican City State",
        "currency_name": "Euro",
        "currency": "EUR",
        "currency_with_symbol": "EUR",
        "flag_img": "https://flagpedia.net/data/flags/h80/va.png",
        "country_code": "VA",
        "locale": "de-DE"
    },
    {
        "country_name": "Venezuela",
        "currency_name": "Venezualan bolivar fuerte",
        "currency": "VEF",
        "currency_with_symbol": "VEF",
        "flag_img": "https://flagpedia.net/data/flags/h80/ve.png",
        "country_code": "VE"
    },
    {
        "country_name": "Vietnam",
        "currency_name": "Vietnamese đồng",
        "currency": "VND",
        "currency_with_symbol": "VND",
        "flag_img": "https://flagpedia.net/data/flags/h80/vn.png",
        "country_code": "VN",
        "locale": "vi-VN"
    },
    {
        "country_name": "Wallis and Futuna Islands",
        "currency_name": "French pacific franc",
        "currency": "XPF",
        "currency_with_symbol": "XPF",
        "flag_img": "https://flagpedia.net/data/flags/h80/wf.png",
        "country_code": "WF"
    },
    {
        "country_name": "Western Sahara",
        "currency_name": "Moroccan dirham",
        "currency": "MAD",
        "currency_with_symbol": "MAD",
        "flag_img": "https://flagpedia.net/data/flags/h80/eh.png",
        "country_code": "EH",
        "locale": "ar-MA"
    },
    {
        "country_name": "Western Samoa",
        "currency_name": "Samoan tala",
        "currency": "WST",
        "currency_with_symbol": "WST",
        "flag_img": "https://flagpedia.net/data/flags/h80/ws.png",
        "country_code": "WS"
    },
    {
        "country_name": "Yemen",
        "currency_name": "Yemeni rial",
        "currency": "YER",
        "currency_with_symbol": "YER",
        "flag_img": "https://flagpedia.net/data/flags/h80/ye.png",
        "country_code": "YE",
        "locale": "ar-YE"
    },
    {
        "country_name": "Yugoslavia",
        "currency_name": "Yugoslav dinar",
        "currency": "YUN",
        "currency_with_symbol": "YUN",
        "flag_img": "https://flagpedia.net/data/flags/h80/yu.png",
        "country_code": "YU"
    },
    {
        "country_name": "Zambia",
        "currency_name": "Zambian kwacha",
        "currency": "ZMW",
        "currency_with_symbol": "ZMW",
        "flag_img": "https://flagpedia.net/data/flags/h80/zm.png",
        "country_code": "ZM",
        "locale": "en-ZM"
    },
    {
        "country_name": "Zimbabwe",
        "currency_name": "US dollar",
        "currency": "USD",
        "currency_with_symbol": "$",
        "flag_img": "https://flagpedia.net/data/flags/h80/zw.png",
        "country_code": "ZW",
        "locale": "en-US"
    }
];

export default countries;